import Tab from '@blocks/Filter/Tab'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import Select from '@blocks/Select'
import React from 'react'

export default function SalonVoteSections({ sections, archive }: Props) {
    const filter = archive.filter<number>("sections", filterBySection)

    return (
        <Select 
            id="sections" 
            name="sections"
            label="Sections"
            background="#fff"
            height="s"
            isClearable
            options={sections.map(section => ({ label: section.name, value: section.id.toString()}))}
            onChange={
                (option: Interfaces.Options[0]) => {
                    if (!option?.value) {
                        filter.reset()
                        return
                    }
                    
                    filter.set(parseInt(option.value))
                }
            }
        /> 
    )
}

const filterBySection: ArchiveHookFilterRule<Jury.Resources.Nomination, number>["fn"] = (data, value) => {
    return data?.filter(participation => participation.section.id === value)
}

interface Props {
    sections: Interfaces.Section[]
    archive: ArchiveHookResponse<Jury.Resources.Nomination>
}